import { defineComponent as _defineComponent } from 'vue'
import { getServices } from '@/app/services';
import { useRequestManager } from 'ah-common-lib/src/requestManager/useRequestManager';
import config from '@/config';


export default /*#__PURE__*/_defineComponent({
  __name: 'PartnerTrainingView',
  setup(__props) {

const requestManager = useRequestManager();
const services = getServices();

function openHedgucation() {
  requestManager.manager
    .sameOrCancelAndNew(
      'generateCode',
      services.auth.generateOAuthCode({
        clientId: config.hedgucationSsoClientId,
        redirectUri: config.hedgucationRedirectUri,
      })
    )
    .subscribe((res) => window.open(`${config.hedgucationRedirectUri}?code=${res.code}`, '_blank'));
}

return { __sfc: true,requestManager, services, openHedgucation }
}

})